<template>
  <div class="wrap">
    <div class="title">
      <div class="title_left">供应商管理</div>
    </div>
    <div class="innerBox">
      <div class="filtrate">
        <el-input placeholder="供应商名称" class="w300 seekIpt mr20" v-model="queryLimit.keyWord" @keyup.enter.native="searchPage">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
        </el-input>
        <div class="floatR">
          <el-button class="w90 pl" @click="deleteBatch">批量删除</el-button>
          <el-button class="selectHeight mr20" type="primary" @click="openAdd">
            <i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
          </el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="tabOffTop120">
          <el-table ref="multipleTable" :data="tableData.records" tooltip-effect="dark" style="width: 100%" @selection-change="selectionChange">
            <el-table-column type="selection" width="80"></el-table-column>
            <el-table-column prop="name" min-width="160" label="供应商名称"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="areaName" min-width="160" label="所在区域" show-overflow-tooltip></el-table-column>
            <el-table-column prop="addr" min-width="180" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column prop="legalPerson" min-width="100" label="法人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tel" min-width="120" label="联系方式" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="180">
              <template slot-scope="scope">
                <a href="javascript:;" class="operate-a" @click="openEdit(scope.row)">编辑</a>
                <a href="javascript:;" class="operate-a" @click="openDetail(scope.row)">详情</a>
                <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row.id)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                          :current-page="queryLimit.pageNum" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.pageSize"
                          layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "api/report";
  export default {
    data() {
      return {
        queryLimit: {
          pageNum: 1,
          keyWord: "",
          pageSize: 10
        },
        tableData: [],
        idArr: []
      };
    },
    methods: {
      selectionChange(row){
        for(let i=0;i<row.length;i++){
          this.idArr.push(row[i].id)
        }
      },
      pageCurrentChange(current) {
          this.queryLimit.pageNum = current;
          this.getPageData();
      },
      pageSizeChange(size) {
          this.queryLimit.pageSize = size;
          this.getPageData();
      },
      // 删除
      async delConfirm(id){
          try {
              await this.$confirm('删除后此条商品无法溯源，是否确定删除? ', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
              api.goodsSupplyDelete({ supplyIdList: [id]}).then(res => {
                if(res.code === 200) {
                  this.$message.success('删除成功!');
                  this.getPageData();
                }
              }).catch(err => {})
          } catch (e) {
              this.$message({
                  type: 'info',
                  message: '删除失败'
              });
          }
      },
      async deleteBatch(){
        try {
          await this.$confirm('删除后所有选中商品无法溯源，是否确定删除? ', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          api.goodsSupplyDelete({ supplyIdList: this.idArr }).then(res => {
            if (res.code === 200) {
              this.$message.success('删除成功!');
              this.getPageData();
            }
          }).catch(err => { })
        } catch (e) {
          this.$message({
            type: 'info',
            message: '删除失败'
          });
        }
      },
      openDetail(row) {
        this.$router.push({name: 'sourceFill.supplierFillInfo', query: {type: 'detail', id: row.id}})
      },
      openEdit(row){
        this.$router.push({name: 'sourceFill.supplierFillAdd', query: {type: 'edit', id: row.id}})
      },
      openAdd(){
        this.$router.push({name: 'sourceFill.supplierFillAdd', query: {type: 'add'}})
      },
      searchPage(){
        this.queryLimit.current = 1;
        this.getPageData();
      },
      async getPageData(){
        api.supplyListPage(this.queryLimit).then(res => {
          if(res.code === 200) {
            this.tableData = res.data
          }
        })
      }
    },
    mounted() {
      this.getPageData();
    }
  };
</script>

<style scoped lang="scss">
  .wrap {
    width: calc(100% - 40px);
    padding: 0 20px;
    height: 100%;
    background: #f6f6f6;
    .title {
      height: 60px;
      line-height: 60px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
      }
    }
    .innerBox {
      width: calc(100% - 60px);
      padding: 20px 30px;
      height: calc(100% - 125px);
      background: #fff;
      border-radius: 10px;
      overflow: scroll;
      .filtrate {
        vertical-align: center;
        color: #666666;
        font-size: 12px;
      }
    }
    .pagination-box {
      text-align: right;
      margin-top: 20px;
    }
  }
</style>